import React, { FC, useEffect, useMemo } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { AzureApi } from '../../api/AzureApi';
import { useUniversalLogin } from '../../hooks/useUniversalLogin';

const AzureAuthenticationPage: FC = () => {
	const history = useHistory();

	const search = useMemo(() => history?.location?.search, [history]);
	const { isAuthenticated } = useUniversalLogin();

	useEffect(() => {
		if (search) {
			const queryParams = new URLSearchParams(search);
			const code = queryParams.get('code');
			if (code) {
				AzureApi.getAndSaveAzureToken(code);
			}
		}
	}, [search]);

	if (!isAuthenticated()) {
		return <Redirect to="/login" />;
	}

	return <EvSpinner />;
};

export { AzureAuthenticationPage };
